import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import type {
  AreaDetailsErrors,
  AreaDetailsItems,
  AreaRelatedItems,
  RecommendedAreaResponse,
} from 'AreaDetails-Types';

import { fetchAreaDetailsAsync, fetchAreaRelatedAsync, fetchRecommendedAreaAsync } from './actions';

export const isFetching = createReducer(false as boolean)
  .handleAction(
    [
      fetchAreaDetailsAsync.request,
      fetchRecommendedAreaAsync.request,
      fetchAreaRelatedAsync.request,
    ],
    (state, action) => true,
  )
  .handleAction(
    [
      fetchAreaDetailsAsync.success,
      fetchAreaDetailsAsync.failure,
      fetchRecommendedAreaAsync.success,
      fetchRecommendedAreaAsync.failure,
      fetchAreaRelatedAsync.success,
      fetchAreaRelatedAsync.failure,
    ],
    (state, action) => false,
  );

export const items = createReducer({} as AreaDetailsItems).handleAction(
  fetchAreaDetailsAsync.success,
  (_state, action) => action.payload,
);

export const recommendedArea = createReducer({} as RecommendedAreaResponse).handleAction(
  fetchRecommendedAreaAsync.success,
  (_state, action) => {
    const { areas } = action.payload;
    return { areas };
  },
);

export const areaRelatedItems = createReducer({} as AreaRelatedItems).handleAction(
  fetchAreaRelatedAsync.success,
  (_state, action) => action.payload,
);

export const errors = createReducer({} as AreaDetailsErrors).handleAction(
  [fetchAreaDetailsAsync.failure, fetchRecommendedAreaAsync.failure, fetchAreaRelatedAsync.failure],
  (_state, action) => action.payload,
);

const areaDetailsReducer = combineReducers({
  isFetching,
  items,
  recommendedArea,
  areaRelatedItems,
  errors,
});

export default areaDetailsReducer;
export type AreaDetailsState = ReturnType<typeof areaDetailsReducer>;
